import client from './client';
import { clearChatMessages as clearChatMessagesApi } from './gameApi';

export const listAdminUsers = (includeArchived = false) => client.get(`/admin/users?includeArchived=${includeArchived ? 'true' : 'false'}`);
export const updateAdminUserRole = (userId, role) => client.patch(`/admin/users/${userId}/role`, { role });
export const updateAdminUserProfile = (userId, payload) => client.patch(`/admin/users/${userId}/profile`, payload);
export const setAdminUserActiveStatus = (userId, isActive) => client.patch(`/admin/users/${userId}/active`, { isActive });
export const resetAdminUserPassword = (userId, newPassword) => client.patch(`/admin/users/${userId}/password`, { newPassword });
export const listAdminOpenGames = () => client.get('/admin/games/open');
export const setAdminGameAuditLog = (gameId, enabled) => client.patch(`/admin/games/${gameId}/audit-log`, { enabled });
export const getAdminGameAuditLog = (gameId, limit = 300) => client.get(`/admin/games/${gameId}/audit-log?limit=${limit}`);
export const clearAdminGameAuditLog = (gameId) => client.delete(`/admin/games/${gameId}/audit-log`);
export const getAdminDirectMessageAudit = ({ roomCode, userId, limit = 400 } = {}) => {
	const params = new URLSearchParams();
	if (roomCode) params.set('roomCode', roomCode);
	if (userId) params.set('userId', userId);
	params.set('limit', `${limit}`);
	return client.get(`/admin/chat/direct-messages?${params.toString()}`);
};
export const clearAdminChatHistory = clearChatMessagesApi;
export const closeAdminGame = (gameId) => client.patch(`/admin/games/${gameId}/close`);
export const reopenAdminGame = (gameId) => client.patch(`/admin/games/${gameId}/reopen`);
export const deleteAdminGameRecord = (gameId) => client.delete(`/admin/games/${gameId}`);
export const getAdminStatsAudit = () => client.get('/admin/stats/audit');
export const reconcileAdminUserStats = (userId) => client.patch(`/admin/stats/reconcile/${userId}`);
export const createRegistrationInvite = (payload) => client.post('/admin/registration-invites', payload);
export const getRegistrationSettings = () => client.get('/admin/registration-settings');
export const updateRegistrationSettings = (payload) => client.patch('/admin/registration-settings', payload);
export const getBattleCrySettings = () => client.get('/admin/battle-cries');
export const updateBattleCrySettings = (payload) => client.patch('/admin/battle-cries', payload);
